export const MATCHED_TAG_CASSETTE_AB_TEST_KEY = 'ab_dodasite_26488';

export const MatchedTagCassetteABTestPattern = {
  ORIGINAL: 1,
  TEST1: 2,
  TEST2: 3,
  FAIL: 9,
} as const;
